/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 * 
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */
const fill = "1e1e1e"; // don't add the `#`
const onImageFallback = (e: any) => {
  const target = e.target as HTMLImageElement;
  target.onerror = null; // prevent infinite loop if fallback image fails
  target.src = `data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 200 200'%3E%3Crect width='200' height='200' fill='%23${fill}'/%3E%3C/svg%3E`;
  target.width = 200;
  target.height = 200;
};

export default onImageFallback;
